import React, { useState } from "react";
import ProfileViewEdit from "./_ProfileViewEdit";
import ProfileChangePassword from "./_ProfileChangePassword";
import ProfileReset2FAConfig from "./_ProfileReset2FAConfig";
const ProfileSidebar = ({
  handleProfileSidebar,
  SignoutUser,
  _,
  SidebarHiding,
  UserProfile,
  canChangePassword,
}) => {
  const [EditProfile, setEditProfile] = useState(false);
  const [Mode, setMode] = useState("ViewEdit");
  return (
    <div
      className={
        "notifications profile-sidebar" + (SidebarHiding ? " hiding" : "")
      }
      onClick={handleProfileSidebar}
    >
      <div
        className={"notifications-wrapper " + (SidebarHiding ? " hiding" : "")}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="btn btn-close" onClick={handleProfileSidebar}>
          <i className="icon-omni-close-circle" />
        </button>

        <div
          className={
            "profile-slide" +
            (Mode === "ViewEdit"
              ? " slide-left"
              : " change-password slide-right")
          }
        >
          <div className="leftSlide">
            <ProfileViewEdit
              {...{
                EditProfile,
                setEditProfile,
                handleProfileSidebar,
                SignoutUser,
                setMode,
                _,
                SidebarHiding,
                UserProfile,
                canChangePassword,
              }}
            />
          </div>
          <div className="rightSlide">
            {Mode === "ChangePwd" ? (
              <ProfileChangePassword
                {...{ setMode, handleProfileSidebar, _ }}
              />
            ) : (
              ""
            )}
            {Mode === "Reset2FAConfig" ? (
              <ProfileReset2FAConfig
                {...{ setMode, handleProfileSidebar, _ }}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProfileSidebar;
